// REACT_APP_API_BASE can be set in root .env.local file to override API URL, e.g. in JS Dev mode
const apiBase = process.env.REACT_APP_API_BASE ? process.env.REACT_APP_API_BASE : '';
const config = {
    apiBase,
    env: process.env.NODE_ENV,
}

export default config;
